const {CLIENT_ID, ISSUER} = process.env;

export default {
    oidc: {
        clientId: CLIENT_ID,
        issuer: ISSUER,
        redirectUri: 'https://tico2e.indiancarbon.org/implicit/callback',
        scopes: ['openid', 'profile', 'email'],
        pkce: true,
        testing: {
            disableHttpsCheck: false
        }
    },
    resourceServer: {
        messagesUrl: 'http://tico.green2sustainable.com/api/messages'
    }
};



// WEBPACK FOOTER //
// ./src/config.js